import { FEEDBACK_MESSAGES, REGEXS, URL_TO_POP_UP, URL_VISITED } from '../config'
import { generateLead } from '../services/generateLead'
import { createFundoAmbientalModal } from './fundoAmbientalBuild'
import { getBysideId } from './getBysideId'
import { getVisitorId } from './getVisitorId'

export function fundoAmbientalModal () {
  if (!URL_TO_POP_UP.includes(URL_VISITED)) return

  setTimeout(() => {
    document.body.appendChild(createFundoAmbientalModal())

    const $overlay = document.querySelector('.fundo-ambiental-modal__overlay')
    const $form = document.getElementById('fundo-ambiental-modal__form')
    const $btnCustomDsaWrap = document.querySelector('.walmeric_btn_modal')
    const $btnCloseModal = document.querySelector('.fundo-ambiental-modal__close')

    $btnCloseModal.addEventListener('click', () => {
      $overlay.style.display = 'none'
    })

    if ($btnCustomDsaWrap !== null) {
      const btnToShowModal = document.createElement('button')
      btnToShowModal.classList.add('fundo-ambiental__custom-dsa')
      btnToShowModal.onclick = () => { $overlay.style.display = 'flex' }
      btnToShowModal.innerText = 'Liguem-me'

      $btnCustomDsaWrap.appendChild(btnToShowModal)
    }

    if ($form !== null) {
      getVisitorId()
      getBysideId()
      const $$inputs = $form.querySelectorAll('.fundo-ambiental-modal__input')
      const $privacyPolicy = $form.querySelector('#policy-checkbox')

      $$inputs.forEach((input) => {
        input.addEventListener('input', () => {
          const { nextElementSibling: errorMessage } = input
          if (errorMessage !== null) {
            errorMessage.remove()
            input.classList.remove('error')
          }
        })
      })

      $form.addEventListener('submit', (event) => {
        event.preventDefault()
        const formData = new FormData(event.target)
        const data = Object.fromEntries(formData)

        const setErrorMessage = ({ input, msg, element }) => {
          if (input.classList.contains('error')) return
          const createErrorMessage = document.createElement('p')
          createErrorMessage.classList.add('error-msg')
          createErrorMessage.innerText = msg
          input.classList.add('error')
          element.appendChild(createErrorMessage)
        }

        $$inputs.forEach(input => {
          const { name, value, parentElement } = input

          if (name === 'name' && value === '') {
            setErrorMessage({
              input,
              element: parentElement,
              msg: FEEDBACK_MESSAGES.ERROR.NAME_REQUIRED
            })
          }

          if (name === 'name' && !REGEXS.JUST_LETTERS.test(value)) {
            setErrorMessage({
              input,
              element: parentElement,
              msg: FEEDBACK_MESSAGES.ERROR.NAME_INVALID
            })
          }

          if (name === 'phone' && value === '') {
            setErrorMessage({
              input,
              element: parentElement,
              msg: FEEDBACK_MESSAGES.ERROR.PHONE_REQUIRED
            })
          }

          if (name === 'phone' && !REGEXS.PORTUGUESE_NUMBER.test(value)) {
            setErrorMessage({
              input,
              element: parentElement,
              msg: FEEDBACK_MESSAGES.ERROR.PHONE_INVALID
            })
          }
        })

        if (!$privacyPolicy.checked) {
          const { parentElement } = $privacyPolicy.parentElement

          setErrorMessage({
            input: $privacyPolicy,
            element: parentElement,
            msg: FEEDBACK_MESSAGES.ERROR.PRIVACY_POLICY
          })
        }

        if ($privacyPolicy.checked && $privacyPolicy.classList.contains('error')) {
          const { parentElement } = $privacyPolicy.parentElement
          const errorMessage = parentElement.querySelector('.error-msg')
          $privacyPolicy.classList.remove('error')
          errorMessage.remove()
        }

        const thereAreErrors = document.querySelectorAll('.error-msg')
        if (thereAreErrors.length > 0) return

        console.log('enviando datos')

        generateLead(event, { data })
      })
    }
  }, 2000)
}

/**
 * Leads de prueba:
 * 351968893739
 */
